<template>
    <div class="customer-detail-address">
        <el-table border :data="addressList" :size="GCONFIG.styleTableSize">
            <el-table-column label="基本信息">
                <template slot="header" slot-scope="scope">
                    <el-button type="danger" size="mini" class="header-btn" @click="openDraw">新增</el-button>
                    <span>客户地址</span>
                </template>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="收件人" width="100" prop="consigneeName"></el-table-column>
                <el-table-column prop="consigneePhone" label="电话" width="110"></el-table-column>
                <el-table-column label="省" prop="provinceName" width="100"></el-table-column>
                <el-table-column prop="cityName" label="市" width="100"></el-table-column>
                <el-table-column prop="areaName" label="区" width="100"></el-table-column>
                <el-table-column prop="address" label="详细地址"></el-table-column>
                <el-table-column prop="lastTime" label="使用时间" width="160"></el-table-column>
                <el-table-column label="类型" width="80">
                    <template slot-scope="scope">
                        <el-tag>{{addressTypeObj[scope.row.addressType]}}</el-tag>
                    </template>
                </el-table-column>
            </el-table-column>

        </el-table>
        <el-drawer
                title="新增地址(都是必填项)"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose">
            <el-form ref="form" :model="formData" label-width="80px" class="draw-box">
                <el-form-item label="收件人">
                    <el-input v-model="formData.consigneename"></el-input>
                </el-form-item>
                <el-form-item label="收件手机">
                    <el-input v-model="formData.consingeephone" type="number" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="地址选择">
                    <el-cascader
                            placeholder="请选择省市区"
                            v-model="cityValue"
                            :options="addressCityList"
                            :props="{value:'Id',label:'Name',children:'VoList'}"
                            @change="handleCasChange"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input v-model="formData.address"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="formData.addresstype" placeholder="请选择类型">
                        <el-option
                                v-for="item in addressTypeArr"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addressSubmit">立即保存</el-button>
                </el-form-item>
            </el-form>
        </el-drawer>
    </div>
</template>
<script>
    import {getCustomerAddressListInfo,getCustomerAddressCityAreaList,getCustomerAddressTypeList,customerAddressSubmit} from '@/api/api'
    export default{
        data(){
            return {
                addressList:[],
                addressCityList:[],
                addressTypeObj:{},
                addressTypeArr:[],
                drawerShow:false,
                cityValue:'',
                formData:{
                    customerId:this.$route.params.id,
                    addrId:'',
                    consingeephone:'',
                    consigneename:'',
                    address:'',
                    addresstype:'',
                    areaid:''
                }
            }
        },
        mounted(){
            this.getUserAddressList()
            this.getUserAddressTypeList()
        },
        methods:{
            getUserAddressList(){
                getCustomerAddressListInfo({customerId:this.$route.params.id}).then(res=>{
                    console.log(res)
                    this.addressList = res.data.value
                })
            },
            getUserAddressTypeList(){
                getCustomerAddressTypeList({}).then(res=>{
                    console.log(res)
                    let data = res.data.value;
                    let newObj = {'0':'默认'}
                    data.forEach(item=>{
                        newObj[item.value] = item.name
                    })
                    this.addressTypeObj = newObj
                    this.addressTypeArr = data
                })
            },
            getAddressCityList(){
                getCustomerAddressCityAreaList({transportType:1,isLongPeriodBuy:0}).then(res=>{
                    console.log(res)
                    let add = res.data.value.provinceVoList
                    let newArr = add.map(item=>{
                        item = this.setCityKey(item)
                        item.VoList = item.VoList.map(item1=>{
                            item1 = this.setCityKey(item1)
                            item1.VoList = item1.VoList.map(item2=>{
                                item2 = this.setCityKey(item2)
                                return item2
                            })
                            return item1
                        })
                        return item
                    })
                    this.addressCityList = newArr
                })

            },
            openDraw(item){
                this.drawerShow = true;
                this.getAddressCityList();
            },
            setCityKey(obj){
                let newObj = {}
                let reg = /Name|Id|VoList/
                for(let key in obj){
                    if(reg.test(key)){
                        newObj[key.match(reg)[0]] = obj[key]
                    }
                }
                return newObj
            },
            handleClose(done) {
                done();
                this.formData.addrId = ''
                this.formData.consingeephone = ''
                this.formData.consigneename = ''
                this.formData.address = ''
                this.formData.addresstype = ''
                this.formData.areaid = '';
                this.cityValue = ''
            },
            handleCasChange(val){
                this.formData.areaid = val.length>=3?val[2]:'';
            },
            addressSubmit(){
                if(this.formData.consingeephone.length!=11){
                    this.$notify({
                        title: '警告',
                        message: '请输入正确的手机号',
                        type: 'warning'
                    });
                    return false
                }
                customerAddressSubmit(this.formData).then(res=>{
                    if(res.data.status == 200){
                        this.drawerShow = false;
                        this.$message({
                            message: '恭喜你，地址保存成功',
                            type: 'success'
                        });
                        this.getUserAddressList()
                        this.formData.addrId = ''
                        this.formData.consingeephone = ''
                        this.formData.consigneename = ''
                        this.formData.address = ''
                        this.formData.addresstype = ''
                        this.formData.areaid = '';
                        this.cityValue = ''
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-address{
        .header-btn{
            float: right;
        }
        .draw-box{
            padding: 5px;
        }


    }
    .el-drawer__body{
        padding: 5px;
        .el-cascader{
            width: 100%;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/userSystem/customerAddress.vue